// Build60 accumulates album/review pages. Web keeps its approved batch size and
// fills complete wide rows, without scanning ahead just to count distant pages.
export function uniqueBrowseItems(kind, args, pages) {
  const seen = new Set();
  const excluded = new Set((args.windowExcludedIds || []).map(String));
  return pages
    .flatMap((page) => page.albums)
    .filter((item) => {
      if (!item || (kind === 'reviews' && !item.content?.trim())) return false;
      const id =
        kind === 'albums' ? item.id : args.view === 'albums' ? item.albumId : item.reviewId;
      if (id == null || seen.has(String(id)) || (kind === 'albums' && excluded.has(String(id))))
        return false;
      seen.add(String(id));
      return true;
    });
}
export async function loadBrowseBatch(kind, args, page, source, signal, load) {
  const pages = source?.pages ? [...source.pages] : [];
  let complete = source?.complete || false;
  const offset = source?.consumed || 0;
  // Ads already occupy slots in the first batch; later batches add whole rows.
  const size = page === 1 ? args.windowSize || args.size : args.windowStep || args.size;
  const needed = offset + size;
  let items = uniqueBrowseItems(kind, args, pages);
  while (!complete && items.length < needed) {
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    const rawPage = pages.length + 1;
    const result = await load(kind, { ...args, page: rawPage, size: args.size }, signal);
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    const total = Number(result.pagination?.totalPages);
    if (
      Number(result.pagination?.currentPage) !== rawPage ||
      !Number.isSafeInteger(total) ||
      total < 0 ||
      !Array.isArray(result.albums)
    )
      throw new Error('Invalid browse pagination');
    pages.push(result);
    complete = rawPage >= total;
    items = uniqueBrowseItems(kind, args, pages);
  }
  return {
    albums: items.slice(offset, needed),
    pagination: {
      currentPage: page,
      totalPages: page + Number(!complete || items.length > needed),
    },
    hasMore: !complete || items.length > needed,
    source: { pages, complete, consumed: needed },
  };
}
